<template>
  <div class="joditBox" :class="editorClass">
    <jodit-vue
      v-model="joditContent"
      :config="editorOption.configs"
      :buttons="editorOption.buttons"
    />
    <input type="hidden" v-model="value" />
  </div>
</template>

<script>
import Helpers from '@/util/helpers'
import JoditVue from '@/components/JoditVue'

export default {
  name: 'jodit-editor',
  components: {
    JoditVue
  },
  props: ['value', 'setConfigs', 'editorClass'],
  watch: {
    value (val) {
      this.joditContent = val
    },
    joditContent (val) {
      this.$emit('input', val)
    }
  },
  data () {
    return {
      joditContent: '',
      editorOption: {
        configs: {
          saveHeightInStorage: false,
          allowResizeX: false,
          allowResizeY: true,
          toolbarButtonSize: 'large',
          enter: 'BR',
          colorPickerDefaultTab: 'color',
          showTooltip: false,
          showXPathInStatusbar: false,
          showWordsCounter: false,
          showCharsCounter: true,
          language: 'ko',
          i18n: {
            ko: {
              'Type something': 'メッセージを入力してください。',
              'Bold': '太く',
              'Drop image': 'ファイルをここに置くか',
              'or click': 'クリックして下さい'
            }
          },
          enableDragAndDropFileToEditor: true,
          uploader: {
            url: process.env.BASE_URL + '/api/external/multiFileSingleUpload',
            isImages: false,
            fileName: '',
            insertImageAsBase64URI: false,
            prepareData: function (formData) {
              formData.append('loginId', 'emilEditor')
              return formData
            },
            isSuccess: function (resp) {
              return resp.code === 0
            },
            error: function () {
              this.jodit.events.fire('errorMessage', 'ファイルのアップロードに失敗しました。')
            },
            defaultHandlerSuccess: function (data) {
              // mac에서 작성한 한글 파일의경우 자음, 모음 따로 배열처럼 저장돼 normalize사용, 다만 익스플로러는 지원하지않아 그냥 이름 사용
              const browser = navigator.userAgent.toLowerCase()
              const IEcheck = (navigator.appName === 'Netscape' && navigator.userAgent.search('Trident') !== -1) || (browser.indexOf('msie') !== -1)

              /* 다충 코드 처리
              data.forEach((k) => {
                // image tag 삽입
                if (k.isImage) {
                  const imgElm = this.jodit.create.element('img')
                  imgElm.setAttribute('src', k.url)
                  this.jodit.selection.insertImage(imgElm, null, this.jodit.options.imageDefaultWidth)
                } else {
                  try {
                    const elm = this.jodit.create.element('a')
                    let fileName = Helpers.editExtensionRemove(k.fileOriginalName)
                    elm.setAttribute('href', k.url)
                    elm.setAttribute('target', '_blank')
                    this.jodit.selection.insertNode(elm)
                    elm.textContent = IEcheck ? fileName : fileName.normalize('NFC')
                  } catch (e) {
                    console.log(e)
                  }
                }
                this.jodit.selection.insertNode(this.jodit.create.element('br'))
                this.jodit.selection.insertNode(this.jodit.create.element('br'))
              })
             */
              // 단일 업로드 변경------------------------------------------------------
              // image tag 삽입
              const elm = this.jodit.create.element('a')
              elm.setAttribute('href', data.url)
              elm.setAttribute('target', '_blank')
              this.jodit.selection.insertNode(elm)
              if (data.isImage) {
                const imgElm = this.jodit.create.element('img')
                imgElm.setAttribute('src', data.url)
                this.jodit.selection.insertImage(imgElm, null, this.jodit.options.imageDefaultWidth)
                elm.appendChild(imgElm)
              } else {
                try {
                  let fileName = Helpers.editExtensionRemove(data.fileOriginalName)
                  elm.textContent = IEcheck ? fileName : fileName.normalize('NFC')
                } catch (e) {
                  console.log(e)
                }
              }
              this.jodit.selection.insertNode(this.jodit.create.element('br'))
              this.jodit.selection.insertNode(this.jodit.create.element('br'))
              // 단일 업로드 ------------------------------------------------------------
            }
          }
        }
      }
    }
  },
  created () {
    const merge = (target, source) => {
      for (let key of Object.keys(source)) {
        if (source[key] instanceof Object) Object.assign(source[key], merge(target[key], source[key]))
      }
      Object.assign(target || {}, source)
      return target
    }
    merge(this.editorOption, this.setConfigs)
  }
}
</script>

<style lang="scss">
.joditBox {
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/JoditEditor.vue